import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { catchError, throwError } from 'rxjs';
import { AppState } from '../../reducers';
import { SessionExpired } from '../store/auth.actions';
import { tokenSelector } from '../store/auth.selectors';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store<AppState>);
  const token = store.selectSignal(tokenSelector)();

  if (token && !req.headers.has('Authorization')) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(req).pipe(
    catchError((error: unknown) => {
      if ((error as HttpErrorResponse)?.url?.includes('userflow')) {
        return;
      }
      if ((error as HttpErrorResponse)?.url?.includes('intercom')) {
        return;
      }
      if ((error as HttpErrorResponse)?.url?.includes('cdn')) {
        return;
      }
      if (error instanceof HttpErrorResponse && error.status === 401 && token) {
        console.warn({ errorIntercepted: error });
        store.dispatch(new SessionExpired());
      }
      return throwError(() => error);
    })
  );
};
